import Title from '@cohort/components-xps/components/Title';
import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import React from 'react';

interface TitleWithLeadingIconProps {
  title: string;
  subtitle: string | JSX.Element;
  icon: JSX.Element;
  testId?: string;
  additionalContent?: JSX.Element;
  children?: JSX.Element;
}

const TitleWithLeadingIcon: React.FC<TitleWithLeadingIconProps> = ({
  title,
  subtitle,
  icon,
  testId,
  additionalContent,
  children,
}) => {
  const {hasDarkBg} = useThemeContext();

  return (
    <div className="max-w-3xl md:flex md:justify-center" data-testid={testId}>
      <div className="m-auto h-11 w-11 md:hidden">{icon}</div>
      <div className="mt-7 w-full md:m-auto md:flex">
        <div className="hidden md:mr-6 md:flex md:justify-center lg:mr-10">
          <div className="m-auto">{icon}</div>
        </div>
        <div>
          <div className="space-y-3 text-center md:text-left">
            <Title content={title} />
            <p
              className={classNames(
                'inline-flex items-center justify-center text-center md:justify-start md:text-left',
                hasDarkBg ? 'text-white/60' : 'text-black/60'
              )}
            >
              {subtitle}
            </p>
          </div>
          {children !== undefined && (
            <div className="mt-7 flex justify-center md:block">{children}</div>
          )}
          {additionalContent}
        </div>
      </div>
    </div>
  );
};

export default TitleWithLeadingIcon;
